import { StatusBar } from '../../design'
import { formatTimeOfDay } from '../../lib/time'
import { STATUS_COPY, STATUS_DETAIL_COPY } from './copy'
import { OutageScreen } from './OutageScreen'
import type { StatusEntry } from './store'
import { useServiceStatus } from './useServiceStatus'

const timingOf = (entry: StatusEntry): string => {
  const since = `${STATUS_DETAIL_COPY.since} ${formatTimeOfDay(new Date(entry.since))}`
  if (entry.retryAt === null) return since
  return `${since}，${STATUS_DETAIL_COPY.retryAt} ${formatTimeOfDay(new Date(entry.retryAt))}`
}

export const ServiceStatusBar = () => {
  const { entries, outage, lastSyncedAt } = useServiceStatus()
  if (outage !== null) return <OutageScreen entry={outage} lastSyncedAt={lastSyncedAt} />
  if (entries.length === 0) return null

  return (
    <div className="status-bar">
      {entries.map((entry) => (
        <StatusBar
          key={entry.kind}
          tone={STATUS_COPY[entry.kind].tone}
          title={STATUS_COPY[entry.kind].title}
          detail={entry.detail}
          meta={timingOf(entry)}
        />
      ))}
    </div>
  )
}
